import { getRowObjectToBeDeleted } from "../../../pages/LandingPage/helpers";
import {
  DeletedObjectsList,
  RowData,
  RowDataObject,
  RowDataReducerActionPayload,
  RowDataReducerState,
} from "../../../types";

export const emptyCoRelationArrayAction = (
  payload: Partial<RowDataReducerActionPayload>,
  state: RowDataReducerState,
): RowDataReducerState => {
  const { propertyKey, selectedTabSectionKey } = payload;

  if (!propertyKey) return state;

  const scopedRowData = selectedTabSectionKey
    ? (state.rowData[selectedTabSectionKey] as RowData)
    : null;

  const existingRows = selectedTabSectionKey
    ? ((scopedRowData?.[propertyKey] as RowDataObject[]) ?? [])
    : ((state.rowData[propertyKey] as RowDataObject[]) ?? []);

  const emptyRowData = selectedTabSectionKey
    ? {
        ...state.rowData,
        [selectedTabSectionKey]: {
          ...(state.rowData[selectedTabSectionKey] as RowData),
          [propertyKey]: [],
        },
      }
    : {
        ...state.rowData,
        [propertyKey]: [],
      };

  if (!existingRows.length) {
    return {
      ...state,
      rowData: emptyRowData,
    };
  }

  // Mirror exactly what setDeletedObjectsAction does — accumulate all row
  // IDs before wiping, so the backend knows to inactivate them
  const updatedDeletedObjectsList: DeletedObjectsList = {
    ...state.deletedObjectsList,
  };

  existingRows.forEach((_, rowIndex) => {
    const { currentRowObjectId, deletedObjectWithInactiveStatus } =
      getRowObjectToBeDeleted(
        propertyKey,
        rowIndex,
        state.rowData,
        selectedTabSectionKey,
      );

    if (currentRowObjectId) {
      if (selectedTabSectionKey) {
        const existingTabScope = (updatedDeletedObjectsList[selectedTabSectionKey] as Record<string, unknown[]>) ?? {};
        const existingTabProperty = (existingTabScope[propertyKey] as unknown[]) ?? [];
        updatedDeletedObjectsList[selectedTabSectionKey] = {
          ...existingTabScope,
          [propertyKey]: [...existingTabProperty, deletedObjectWithInactiveStatus],
        } as DeletedObjectsList[string];
      } else {
        const existing = updatedDeletedObjectsList[propertyKey];
        updatedDeletedObjectsList[propertyKey] = [
          ...(Array.isArray(existing) ? existing : []),
          deletedObjectWithInactiveStatus,
        ];
      }
    }
  });

  return {
    ...state,
    rowData: emptyRowData,
    deletedObjectsList: updatedDeletedObjectsList,
  };
};
